import { render, staticRenderFns } from "./LatestPosts.vue?vue&type=template&id=2c5d29f2&scoped=true"
import script from "./LatestPosts.vue?vue&type=script&lang=js"
export * from "./LatestPosts.vue?vue&type=script&lang=js"
import style0 from "./LatestPosts.vue?vue&type=style&index=0&id=2c5d29f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d29f2",
  null
  
)

export default component.exports